<script setup lang="ts">
import { useToast } from '@shared/composables/useToast'

const { toasts, dismiss } = useToast()

const typeStyles: Record<string, string> = {
  success: 'bg-feedback-success text-white',
  error: 'bg-feedback-danger text-white',
  info: 'bg-brand-primary text-white'
}
</script>

<template>
  <Teleport to="body">
    <div class="fixed bottom-md right-md z-50 space-y-sm">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="px-md py-sm rounded-md shadow-lg text-sm cursor-pointer transition-opacity"
        :class="typeStyles[toast.type]"
        @click="dismiss(toast.id)"
      >
        {{ toast.message }}
      </div>
    </div>
  </Teleport>
</template>
